module.exports = __webpack_public_path__ + "135dd3b4176dba163c54de939ddc61cf.ttf";


//////////////////
// WEBPACK FOOTER
// ../app/assets/fonts/FuturaLT-Bold.ttf
// module id = 427
// module chunks = 0